import { useRef, useState } from "react";
import type { ReactNode } from "react";
import { useClickOutside } from "../../hooks";

interface DropdownMenuProps {
  trigger: ReactNode | ((open: boolean) => ReactNode);
  triggerClassName?: string;
  triggerLabel?: string;
  triggerTitle?: string;
  disabled?: boolean;
  align?: "left" | "right";
  placement?: "bottom" | "top";
  panelClassName?: string;
  children: ReactNode | ((close: () => void) => ReactNode);
}

export default function DropdownMenu({
  trigger,
  triggerClassName = "",
  triggerLabel,
  triggerTitle,
  disabled = false,
  align = "left",
  placement = "bottom",
  panelClassName = "",
  children,
}: DropdownMenuProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false), open);
  const close = () => setOpen(false);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={triggerLabel}
        title={triggerTitle}
        className={triggerClassName}
      >
        {typeof trigger === "function" ? trigger(open) : trigger}
      </button>
      {open && (
        <div
          role="menu"
          className={`absolute z-10 ${placement === "top" ? "bottom-full mb-1" : "top-full mt-1"} rounded-lg border border-gray-200 bg-white shadow-md ${align === "right" ? "right-0" : "left-0"} ${panelClassName}`}
        >
          {typeof children === "function" ? children(close) : children}
        </div>
      )}
    </div>
  );
}
